import { Box, Grid, Typography } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import gapGif from 'assets/images/gapAnimation.gif'

const GapLoadingPage = ({
  handleNext,
  adjustedNetTakeHomeDifferencePARCOGap = 0,
}) => {
  const [gifSrc, setGifSrc] = useState(null)
  const dollarFormat = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  })
  useEffect(() => {
    setGifSrc(`${gapGif}?t=${Date.now()}`)
    const timer = setTimeout(() => {
      handleNext()
    }, 6000)

    return () => clearTimeout(timer) // cleanup
  }, [])

  return (
    <Grid key="3" item xs={12} mb={3}>
      <Box>
        <Typography variant="headerTitle" sx={{ color: '#262627' }}>
          Generating an optimal solution to bridge your{' '}
          {dollarFormat.format(Math.abs(adjustedNetTakeHomeDifferencePARCOGap))}
          /month Retirement Gap
        </Typography>
      </Box>
      <Typography variant="body1" mt={3}>
        We are using your responses and your profile information to come up with
        the best solution for your exact situation:
      </Typography>
      <Box sx={{ '& img': { display: 'block', margin: '16px auto 0' } }}>
        <img src={gifSrc} />
      </Box>
    </Grid>
  )
}

export default GapLoadingPage
